import {withBasicData} from 'core/next/controllers';
import {contentController} from 'modules/content/controllers';
import {ContentProvider} from 'modules/content/providers/ContentProvider';
import {NextPage} from 'next';
import React from 'react';

const Page: NextPage = () => {
    return <ContentProvider />;
};

Page.getInitialProps = withBasicData(async (store, ctx) => {
    await contentController(store, ctx);
    return {
        props: {},
    };
});

export default Page;
